import { render, staticRenderFns } from "./ModalReadonly.vue?vue&type=template&id=604d975a&scoped=true&"
import script from "./ModalReadonly.vue?vue&type=script&lang=js&"
export * from "./ModalReadonly.vue?vue&type=script&lang=js&"
import style0 from "./ModalReadonly.vue?vue&type=style&index=0&id=604d975a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d975a",
  null
  
)

export default component.exports